<template>
    <div class="flex border-t border-b -mb-px border-gray-200 bg-white draggable">
        <!-- Draggable handle. -->
        <div class="w-6 flex-shrink-0 self-start py-1.5">
            <div class="w-5 h-5 flex items-center">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"></i>
            </div>
        </div>

        <!-- material. -->
        <supplier-quotes-material-search
            class="flex-1 flex"
            #default="{ open, query, setQuery }"
            :store="store"
            @selected:material="materialSelected"
            :top="true"
        >
            <div class="-ml-px mt-px mb-px px-px py-px pb-px border-l border-r border-gray-200">
                <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'" ref="autoresizable-textarea">
                    <textarea
                        placeholder="Item..."
                        class="col-span-full text-sm -ml-px -my-px pt-1.5 pb-0.5 border-none shadow-none relative hover:z-10 focus:z-20 resize-none"
                        type="text"
                        ref="item"
                        v-model="item.name"
                        rows="1"
                        @input="setQuery($event.target.value);save();"
                        @focus="setQuery($event.target.value);open()"
                        @blur="save"
                    ></textarea>
                </autoresizable-textarea>
            </div>
        </supplier-quotes-material-search>

        <div class="w-24 -ml-px flex">
            <ui-select class="text-xs mx-0 -mt-px p-0 border-l border-r border-gray-200"
                       :select-class="'border-none py-1 mx-px mr-px my-px pt-2 pb-2 text-xs pl-1 pr-[2rem] focus:z-20'"
                       v-model="type"
                       @change="(e) => {item.type = type; save();}"
                       :options="[{value:'Material',label:'Material'},{value:'Labour',label:'Labour'},{value:'Fixed Cost',label:'Fixed Cost'}]"
            ></ui-select>
        </div>

        <div class="w-14 -ml-px flex">
            <page-cell
                class="text-sm mx-0 -my-px px-2 py-1.5 border-l border-r border-gray-200"
                placeholder=""
                v-model="unitOfMeasure"
                @input="save"
                @blur="save"
            ></page-cell>
        </div>

        <div class="w-24 -ml-px flex">
            <page-cell
                currency
                class="text-sm mx-0 -my-px px-2 py-1.5 border-l border-r border-gray-200"
                placeholder="Cost..."
                v-model="costPerUnit"
                @input="save"
                @blur="() => {save(); this.costPerUnit = this.item.costPerUnit }"
            ></page-cell>
        </div>


        <div class="w-6 flex-shrink-0 ml-2 mt-1">
            <ui-dropdown menu-class="p-3 w-56">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-trash" danger @click="removeItem();close();">Delete Item
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import AutoresizableTextarea from "../ui/AutoresizableTextarea";
import {isNull} from "lodash";
import UiDropdown from "../ui/UiDropdown.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import SupplierQuotesMaterialSearch from "./SupplierQuotesMaterialSearch.vue";
import UiSelect from "../ui/UiSelect.vue";
import {resolveNumericText, toCurrency} from "../../utils";

export default {
    components: {
        UiSelect,
        SupplierQuotesMaterialSearch,
        UiDropdownItem, UiDropdown, AutoresizableTextarea
    },
    props: {
        item: Object,
        store: Object,
    },
    data() {
        return {
            resolveNumericText,
            type: this.item.type,
            unitOfMeasure: this.item.unitOfMeasure,
            costPerUnit: this.item.costPerUnit
        }
    },
    methods: {
        isNull,
        removeItem() {
            this.$emit('removeItem', this.item)
        },
        save() {
            this.item.type = this.type
            this.item.unitOfMeasure = this.unitOfMeasure
            this.item.costPerUnit = toCurrency(resolveNumericText(this.costPerUnit, true), 'GBP', 2)
            this.$emit('updatedItem', this.item)
        },
        materialSelected(e) {
            this.item.name = e.materialName;
            this.save();
            this.$nextTick(() => {
                this.$refs['autoresizable-textarea'].resizeTextarea({target: this.$refs['autoresizable-textarea'].$el})
            })
        },
    },
}
</script>
